import { CARD_SHADOW, COLORS } from '../IndividualPlan/tokens';

export const SETTINGS = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  surface: COLORS.bg,
  cardBg: '#FFFFFF',
  divider: COLORS.divider,
  primary: COLORS.navy,
  primaryDark: '#151547',
  tint: '#EFEFFA',
  noteBg: COLORS.bg,
  mark: '#512100',
  error: '#B20101',
  pill: { bg: '#E3E3E8', fg: '#4A4A5F' },
  cardShadow: CARD_SHADOW,
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
  labelWidth: 192,
} as const;
